var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon() && _vm.icon().iconType === 'fontawesome' )?_c('i',{class:_vm.icon().iconName}):_c('i',{attrs:{"data-feather":_vm.name}})}
var staticRenderFns = []

export { render, staticRenderFns }